import React from 'react';
import { X, Package, Calendar, DollarSign, Building, Hash } from 'lucide-react';

const ClientProductsModal = ({ isOpen, onClose, client, products = [] }) => {
    if (!isOpen || !client) return null;

    // Fix: Use correct field name - products instead of clientProducts
    const clientProducts = client.products || [];

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex min-h-screen items-center justify-center p-4">
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                    onClick={onClose}
                />

                <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[80vh] overflow-hidden">
                    <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4">
                        <div className="flex items-center justify-between">
                            <h3 className="text-xl font-semibold text-gray-900">
                                Products for {client.clientType === 'CORPORATE'
                                ? client.name || client.companyName
                                : client.name || `${client.firstName} ${client.lastName}`}
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                    </div>

                    <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]">
                        {clientProducts.length === 0 ? (
                            <div className="text-center py-12">
                                <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                                <p className="text-gray-600 mb-4">No products purchased yet</p>
                                <p className="text-sm text-gray-500">
                                    Total products shown: {client.productCount || 0}
                                </p>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {clientProducts.map((cp, index) => {
                                    // The backend returns ClientProductInfo with these fields:
                                    // productId, productCode, productName, companyName, purchaseDate, status, notes

                                    return (
                                        <div key={cp.productId || index} className="border border-gray-200 rounded-lg p-4">
                                            <div className="flex items-start justify-between">
                                                <div className="flex items-start gap-3">
                                                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                                                        <Package className="w-5 h-5 text-blue-600" />
                                                    </div>
                                                    <div className="flex-1">
                                                        <h4 className="font-medium text-gray-900">
                                                            {cp.productName || 'Unknown Product'}
                                                        </h4>
                                                        <div className="flex items-center gap-4 mt-1">
                                                            <p className="text-sm text-gray-500 flex items-center gap-1">
                                                                <Hash className="w-3 h-3" />
                                                                Code: {cp.productCode || 'N/A'}
                                                            </p>
                                                            <p className="text-sm text-gray-500 flex items-center gap-1">
                                                                <Building className="w-3 h-3" />
                                                                {cp.companyName || 'N/A'}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span className={`px-2 py-1 text-xs rounded-full ${
                                                    cp.status === 'ACTIVE'
                                                        ? 'bg-green-100 text-green-800'
                                                        : cp.status === 'SUSPENDED'
                                                            ? 'bg-yellow-100 text-yellow-800'
                                                            : cp.status === 'CANCELLED'
                                                                ? 'bg-red-100 text-red-800'
                                                                : 'bg-gray-100 text-gray-800'
                                                }`}>
                                                    {cp.status || 'Unknown'}
                                                </span>
                                            </div>

                                            <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
                                                <div>
                                                    <span className="text-gray-500">Purchase Date:</span>
                                                    <p className="text-gray-900 flex items-center gap-1 mt-1">
                                                        <Calendar className="w-4 h-4 text-gray-400" />
                                                        {cp.purchaseDate
                                                            ? new Date(cp.purchaseDate).toLocaleDateString()
                                                            : 'N/A'}
                                                    </p>
                                                </div>
                                                {cp.notes && (
                                                    <div>
                                                        <span className="text-gray-500">Notes:</span>
                                                        <p className="text-gray-900 mt-1">
                                                            {cp.notes}
                                                        </p>
                                                    </div>
                                                )}
                                            </div>

                                            {/* You can add more product details here if needed */}
                                            {cp.expiryDate && (
                                                <div className="mt-3 pt-3 border-t border-gray-100">
                                                    <span className="text-sm text-gray-500">Expiry Date: </span>
                                                    <span className="text-sm text-gray-900">
                                                        {new Date(cp.expiryDate).toLocaleDateString()}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Show total count */}
                        {clientProducts.length > 0 && (
                            <div className="mt-4 pt-4 border-t border-gray-200 text-center">
                                <p className="text-sm text-gray-600">
                                    Total Products: {clientProducts.length}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientProductsModal;
